import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "authSlice",
  initialState: { keycloakData: [], userData: {} },
  reducers: {
    setKeycloakData: (state, action) => {
      state.keycloakData = action.payload;
      state.userData = action.payload.tokenParsed;
    },
    unsetKeycloakData: (state, action) => {
      state.keycloakData = [];
      state.userData = {};
    },
  },
});

export const handleSetSesion = (sesionData) => (dispatch) => {
  dispatch(setKeycloakData(sesionData));
};

export const handleLogOut = () => (dispatch) => {
  dispatch(unsetKeycloakData());
};

export const { setKeycloakData, unsetKeycloakData } = authSlice.actions;
export default authSlice.reducer;
